import { useEffect, useLayoutEffect, useState } from 'react'

import { FooterOrderMaterial } from 'components'
import type { ProductContextState } from 'container/ProductPage'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { useSelector } from 'store/store'

import { shouldShowMultiplicityError } from '../ProductDetail'

interface ProductFooterProps {
  defaultSizes: Record<string, string | string[] | boolean | Record<string, number>>
  onSave: (state: ProductContextState) => Promise<boolean>
  isLoading?: boolean
}

const ProductFooter = ({ defaultSizes, onSave, isLoading = false }: ProductFooterProps) => {
  const { materialSelected, filter } = useSelector((stateProduct) => stateProduct.products)

  const { control, getValues } = useFormContext()
  const { errors } = useFormState()

  const [totalItens, setTotalItens] = useState(0)
  const [isEdit, setIsEdit] = useState(false)

  const hasFilter = filter.length > 0

  const state: ProductContextState = useWatch({
    control: control,
  })

  const isInvalid =
    Object.keys(errors).length > 0 ||
    shouldShowMultiplicityError(
      materialSelected.ds_tipo_caix,
      materialSelected.fl_verf_sku,
      state,
      Number(materialSelected?.qt_item_conv),
    )

  function addToTotal(key: string) {
    if (
      [
        'cd_cent_matr',
        'percentualDesconto',
        'fl_caix_grad',
        'qt_caix_grad',
        'disabledColorsRow',
        'dirtyFieldsByColor',
        'disabled_fl_caix_grad',
      ].includes(key)
    ) {
      return 0
    }
    const objectColor = state[key]
    const color = Object.values(objectColor)

    const subTotal = color?.reduce((accumulator, totalValue) => accumulator + totalValue) || 0

    return subTotal
  }

  const newState: ProductContextState = getValues()
  const currentState = JSON.stringify(newState)
  const oldState = JSON.stringify(defaultSizes)
  const noModification = currentState === oldState
  const handleDraft = async () => {
    const result = await onSave(newState)
    return result
  }

  useLayoutEffect(() => {
    let totalLayout = 0

    for (const key in state) {
      if (hasFilter) {
        if (filter.includes(key.toLowerCase())) {
          const subTotal = addToTotal(key)
          totalLayout = totalLayout + subTotal
        }
      } else {
        const subTotal2 = addToTotal(key)
        totalLayout = totalLayout + subTotal2
      }
    }
    setTotalItens(totalLayout)
    return () => {
      return
    }
  }, [state])

  useEffect(() => {
    let totalVerification = 0
    function addToTotalBoxes(key: string) {
      const subTotal = addToTotal(key)
      totalVerification = totalVerification + subTotal
    }
    const stateForm = getValues()
    for (const key in stateForm) {
      if (hasFilter) {
        if (filter.includes(key.toLowerCase())) {
          addToTotalBoxes(key)
        }
      } else {
        addToTotalBoxes(key)
      }
    }
    if (totalVerification > 0) {
      setIsEdit(true)
    }
  }, [])
  const total = totalItens

  const isEditBtnDisabled = materialSelected.cd_cent_matr === materialSelected.res_cent_matr

  return (
    <>
      {materialSelected?.ds_tipo_caix && (
        <FooterOrderMaterial
          count={total}
          disabled={isInvalid || (isEditBtnDisabled && noModification) || !total}
          loadingButton={isLoading}
          mixedBoxQtd={state?.fl_caix_grad && state?.qt_caix_grad ? Number(state?.qt_caix_grad) : 0}
          onSaveEdit={handleDraft}
          type={isEdit ? 'save' : 'insert'}
        />
      )}
    </>
  )
}

export default ProductFooter
